import React, {useEffect} from 'react'
import {Switch, BrowserRouter, Route, useHistory, Redirect} from 'react-router'

const ScoreCardComponent = () => {

    const history = useHistory();

    useEffect(  () => {
        (async () => {
          await  localStorage.setItem('skygeni-user-page', 'Custom Scorecards')
          await  localStorage.setItem('skygeni-user-personalizedScorecardsPage', "Performance Scorecard")
          await  localStorage.removeItem('skygeni-user-enhancedPage')
          await localStorage.removeItem("skygeni-user-repPage");
      await localStorage.removeItem("skygeni-user-productPage");
    await localStorage.removeItem("skygeni-user-SettingsPage");
    await localStorage.removeItem("skygeni-user-pipelineProgressionPage");
    await localStorage.removeItem("skygeni-user-pipelineVelocityandConversionPage")
    await localStorage.removeItem("skygeni-user--pipelineBuildandSuficencyPage")
    await localStorage.removeItem("skygeni-user-marketIntelandGrowthLeversPage");
    await localStorage.removeItem("skygeni-user-salesProductivityPage");
    await localStorage.removeItem("skygeni-user-growthScienceInsightsPage");
            history.push('/')
            window.location.reload()
        })();   
    },[])

    return(
 <div style={{margin: "1rem auto"}}>Loading...</div>
    )
   
}

export default ScoreCardComponent;